export const getPathnameWithQueryString = (): string => {
  const { pathname, search } = window.location || { pathname: '', search: '' };
  return `${pathname}${search}`;
};
